import TFormInputSearch from './FormInputSearch.vue'

export const FormInputSearch = TFormInputSearch
